/**
 * Given an AlbumMembershipGroup it returns its root.
 *
 * @param {Object} albumMembershipGroup The AlbumMembershipGroup.
 * @returns {undefined|{Object}}
 */
export const getAlbumMembershipGroupRootId = albumMembershipGroup => {
  if (!albumMembershipGroup) {
    return undefined;
  }

  const rootAlbumFolder = albumMembershipGroup.album?.root_album_folder;

  // If the AlbumMembershipGroup belongs to an individual album return the album ID.
  if (rootAlbumFolder?.individual_albums) {
    return albumMembershipGroup.id;
  }

  const rootAlbumFolderId = albumMembershipGroup.album?.root_album_folder?.id;
  const albumFolderId = albumMembershipGroup.album_folder?.id;

  // If we're in an Album with a parent (root) get the root AlbumFolder id,
  // else check if we're in an AlbumFolder.
  // If none exist then we must be in an individual Album so get the Album's id.
  return rootAlbumFolderId || albumFolderId || albumMembershipGroup.album?.id;
};
